import React from "react";
import Customers from "./pages/Customers/Customers";
import Dashboard from "./pages/Dashboard/Dashboard";
import { Routes, Route } from "react-router-dom";
import Users from "./pages/Users/Users";
// import MiniDrawer from "./components/Menu/Drawer";
import Orders from "./pages/orders/Orders";
import Products from "./pages/Products/Products.main";
import Reports from "./pages/Reports/Reports";
import Settings from "./pages/Settings/Settings";
import Login from "./pages/login/Login";
import CreatePassword from "./pages/login/CreatePassword";
import ProtectRoutes from "./pages/ProtectRoutes";
import Packing from "./pages/Packing/Packing";
import UpdatePassword from "./pages/login/UpdatePassword";
import Invoices from "./pages/invoices/Invoices";
// import NewProduct from "./pages/Products/NewProduct";

function App() {
  const menu = [
    {
      component: <Login />,
      path: "/login/*",
    },
    {
      component: <Dashboard />,
      path: "/",
      view: "viewDashboard",
    },
    {
      component: <Customers />,
      path: "/customers/*",
      view: "viewCustomers",
    },
    {
      component: <Users />,
      path: "/users/*",
      view: "viewUsers",
    },
    {
      component: <Products />,
      path: "/products/*",
      view: "viewProducts",
    },
    {
      component: <Orders />,
      path: "/orders/*",
      view: "viewOrders",
    },
    {
      component: <Invoices />,
      path: "/invoices/*",
      view: "viewInvoices",
    },
    {
      component: <Packing />,
      path: "/packing/*",
      view: "viewPacking",
    },
    {
      component: <Reports />,
      path: "/reports/:sheet",
      view: "viewReports",
    },
    {
      component: <Settings />,
      path: "/settings/*",
      view: "viewSettings",
    },
    {
      component: <CreatePassword />,
      path: "/create-password/:token",
      view: "viewCreatePassword",
    },
    {
      component: <UpdatePassword />,
      path: "/update-password/:token",
      view: "viewCreatePassword",
    },
  ];

  return (
    <>
      <Routes>
        {menu.map((item) => (
          <Route
            path={item.path}
            element={
              <ProtectRoutes view={item.view}>{item.component}</ProtectRoutes>
            }
          />
        ))}
      </Routes>
    </>
  );
}

export default App;
